import React, { useContext } from 'react'
import { ToggleNavContext } from '../../helpers/context'
import './maincontainer.css'

export default function MainContainer(props) {
    const { isToggled, setToggle } = useContext(ToggleNavContext);

    return (
        <div className={isToggled ? "dash-content-expand" : "dash-content"}>
            {props.component}
        </div>
    )
}
